import { render, staticRenderFns } from "./dynamic-vote.vue?vue&type=template&id=395b63f2&scoped=true&"
import script from "./dynamic-vote.vue?vue&type=script&lang=js&"
export * from "./dynamic-vote.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-vote.vue?vue&type=style&index=0&id=395b63f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395b63f2",
  null
  
)

export default component.exports